// widgetType=M:目录，C：菜单
// title=组件在组件库显示的标题
// icon=组件在组件库的显示图标
// width=组件在组件库的宽度
// maxUse=组件使用次数
// widgetName=组件名称
// widgetPack=组件路径，注册时候需要转成实际对应的组件

export const widgetMenuList = [
  {
    id: 1, parentId: 0, widgetType: 'M', widgetTitle: '表单',
  },
  {
    id: 10, parentId: 1, widgetType: 'C', widgetTitle: '单行标题', maxUse: 0, style: 'icondanhangshurukuang',
    widgetName: 'widgetTitle',
  },
  {
    id: 11, parentId: 1, widgetType: 'C', widgetTitle: '轮播图', maxUse: 0, icon: 'el-icon-picture',
    widgetName: 'widgetBanner',
  },

  {
    id: 2, parentId: 0, widgetType: 'M', widgetTitle: '图表',
  },
  {
    id: 20, parentId: 2, widgetType: 'C', widgetTitle: '边框', maxUse: 0, style: 'iconkuangjia',
    widgetName: 'widgetBorder',
  },
  {
    id: 22, parentId: 2, widgetType: 'C', widgetTitle: '动态环图', maxUse: 0, icon: 'chart-bingtu',
    widgetName: 'widgetActiveRing',
  },
  {
    id: 24, parentId: 2, widgetType: 'C', widgetTitle: '滚动表格', maxUse: 0, icon: 'chart-gundong-table',
    widgetName: 'widgetScrollTable',
  },

  {
    id: 26, parentId: 2, widgetType: 'C', widgetTitle: '柱状图', maxUse: 0, icon: 'chart-zhuzhuangtu',
    widgetName: 'widgetEchartsBar',
  },

];

